var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value)?_c('Badge',{attrs:{"theme":_vm.theme}},[_vm._v(_vm._s(_vm.$tc('taskType' + _vm.value.toTitleCase())))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }